import { useEffect } from 'react'
import { useEffectEvent } from 'use-effect-event'

import useServices from '@/legacy-src/hooks/useServices'

import { FILTER_SPECIALIZATION_SLUG } from '../filters.constants'
import { useGetFilterValue } from './useGetFilterValue'
import { useSetFilters } from './useSetFilters'

const useShowSpecializations = (): boolean => {
  const { selectedService } = useServices()
  const setFilters = useSetFilters()
  const specializationFilter = useGetFilterValue(FILTER_SPECIALIZATION_SLUG)

  const showSpecializations = selectedService?.showSpecializations !== false
  const hasSpecializationFilter = specializationFilter.length > 0

  const clearHiddenSpecializationFilter = useEffectEvent(() => {
    if (!showSpecializations && hasSpecializationFilter) {
      setFilters([{ slug: FILTER_SPECIALIZATION_SLUG, value: [] }])
    }
  })

  useEffect(() => {
    clearHiddenSpecializationFilter()
    // effect events shouldn't be included in the dependency array, as they are guaranteed to be stable
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showSpecializations, hasSpecializationFilter])

  return showSpecializations
}

export default useShowSpecializations
